module.exports = __webpack_public_path__ + "static/media/testfile_shadowRemoval.e1079647.zip";